import React from "react";
// import { useState } from "react";
import Button from 'react-bootstrap/Button';
import Typography from '@mui/material/Typography';
import { useEffect, useState, useRef } from "react";
import Form from 'react-bootstrap/Form';
 import AromaLevel from "../../components/AromaLevel/AromaLevel";
 import Roast from "../../components/Roast/Roast";
import AromaBreakIntensity from "../AromaLevel/AromaBreakIntensity";
import AromaDryIntensity from "../AromaLevel/AromaDryIntensity";
import FlavourLevel from "../Flavour Level/FlavourLevel";
import FlavourIntensity from "../Flavour Level/FlavourIntensity";
import AftertasteLevel from "../Aftertaste/AftertasteLevel";
import AftertasteIntesity from "../Aftertaste/AftertasteIntesity";
import AcidityLevel from "../Acidity/AcidityLevel";
import AcidityIntensity from "../Acidity/AcidityIntesity";
import MouthfeelIntensity from "../Mouthfeel/MouthfeelIntesity";
import MouthfeelLevel from "../Mouthfeel/MouthfeelLevel";
import UnqinessLevel from "../Unqiness/UnqinessLevel";
import BalanceLevel from "../Balance/BalanceLevel";
import SweetnessIntensity from "../Sweetness/SweetnessIntesity";
import AppCheckBox from "../multiCheckBox/AppCheckBox";
import Aging from "../Mouthfeel/Aging";
import FermentProfile from "../Mouthfeel/Fermentprofile";
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';


const TheStep = ({ data, handleChange,count , handleChangeUni}) => {
  const myInputRef = useRef(0);
  const myInputRef2 = useRef(0);
  const [totals, setInput] = useState();
  const [totald, setInputd] = useState();
  const [setd, setData] = useState();
  useEffect(()=>{
    setInput(myInputRef.current.value);
    setInputd(myInputRef2.current.value)
    setData(totals);
    data.totalscore = setd;
    console.log( "sssssssssssss.......", totals - totald);
  },[data.defectsc, data.defectsintensity])


    const [val1, setVal1] = useState(data.uniformcups1);
  const [val2, setVal2] = useState(data.uniformcups2);
  const [val3, setVal3] = useState(data.uniformcups3);
  const [val4, setVal4] = useState(data.uniformcups4);
  const [val5, setVal5] = useState(data.uniformcups5);
  const [val6, setVal6] = useState(data.cleancupcups1);
  const [val7, setVal7] = useState(data.cleancupcups2);
  const [val8, setVal8] = useState(data.cleancupcups3);
  const [val9, setVal9] = useState(data.cleancupcups4);
  const [val10, setVal10] = useState(data.cleancupcups5);
  const [val11, setVal11] = useState(data.sweetcups1);
  const [val12, setVal12] = useState(data.sweetcups2);
  const [val13, setVal13] = useState(data.sweetcups3);
  const [val14, setVal14] = useState(data.sweetcups4);
  const [val15, setVal15] = useState(data.sweetcups5);
  const [uniformVal,setUnifromVal] = useState([]);
  const [cleanCupVal,setCleanCupVal] = useState([]);
  const [sweetCupVal,setSweetCupVal] = useState([]);
  const stateUniform = {
    uniformCup1: false,
    uniformCup2: false,
    uniformCup3: false,
    uniformCup4: false,
    uniformCup5: false
  };
  function onChangeValueUniform(event) {

    const unformV = [...uniformVal];
    const index = unformV.indexOf(event.target.value);
    if (index === -1) {
      unformV.push(event.target.value);
    } else {
      unformV.splice(index, 1);
    }
    setUnifromVal(unformV);
    let ev={
      "value":unformV,
      "name":"uniformCups"
    }
    console.log(ev);
     handleChange({target:ev});
  }
  function onChangeValueCleanCup(event) {
  
     const cleanV = [...cleanCupVal];
    const index = cleanV.indexOf(event.target.value);
    if (index === -1) {
      cleanV.push(event.target.value);
    } else {
      cleanV.splice(index, 1);
    }
    setCleanCupVal(cleanV);
    const ev={
      value:cleanV,
      name:"cleancupcups"
    }
    handleChange(
      {target:ev}
      
      );
  }
  function onChangeValueSweetness(event) {
    
     const cleanV = [...sweetCupVal];
    const index = cleanV.indexOf(event.target.value);
    if (index === -1) {
      cleanV.push(event.target.value);
    } else {
      cleanV.splice(index, 1);
    }
    setSweetCupVal(cleanV);
    const ev={
      value:cleanV,
      name:"sweetCups"
    }
    handleChange({target:ev});
  }
  function onChangeValue1(event) {
    setVal1(!val1);
    
    console.log(event.target);
    handleChange(event)
    
  }
  function onChangeValue2(event) {
    setVal2(!val2);
    console.log(event.target.value);
    handleChange(event)
  }
  function onChangeValue3(event) {
    setVal3(!val3);
    console.log(event.target.value);
    handleChange(event)
  }
  function onChangeValue4(event) {
    setVal4(!val4);
    console.log(event.target.value);
    handleChange(event)
  }
  function onChangeValue5(event) {
    setVal5(!val5);
    console.log(event.target.value);
    handleChange(event)
  }
  function onChangeValue6(event) {
    setVal6(!val6);
    console.log(event.target.value);
    handleChange(event)
  }
  function onChangeValue7(event) {
    setVal7(!val7);
    console.log(event.target.value);
    handleChange(event)
  }
  function onChangeValue8(event) {
    setVal8(!val8);
    console.log(event.target.value);
    handleChange(event)
  }
  function onChangeValue9(event) {
    setVal9(!val9);
    console.log(event.target.value);
    handleChange(event)
  }
  function onChangeValue10(event) {
    setVal10(!val10);
    console.log(event.target.value);
    handleChange(event)
  }
  
  function onChangeValue11(event) {
    setVal11(!val11);
    console.log(event.target.value);
    handleChange(event)
  }
  function onChangeValue12(event) {
    setVal12(!val12);
    console.log(event.target.value);
    handleChange(event)
  }
  function onChangeValue13(event) {
    setVal13(!val13);
    console.log(event.target.value);
    handleChange(event)
  }
  function onChangeValue14(event) {
    setVal14(!val14);
    console.log(event.target.value);
    handleChange(event)
  }
  function onChangeValue15(event) {
    setVal15(!val15);
    console.log(event.target.value);
    handleChange(event)
  }
  const handleLevelChange = (newLevel) => {
    handleChange(newLevel);
  };
  let totalScore=parseFloat(data.aromalevel) +   
          parseFloat(data.flavourlevel)+parseFloat(data.cleancupscore) +  
          + parseFloat(data.aftertestlevel) +  + parseFloat(data.aciditylevel) +  parseFloat(data.mouthfeellevel) 
          +  parseFloat(data.uniquenesslevel) +parseFloat(data.uniformityscore)+  parseFloat(data.balancelevel) +  parseFloat(data.sweetnessscore);
          let totalDefects=parseFloat(data.defectsc) * parseFloat(data.defectsintensity);          
  return (
    <>
    {/* STEP #1 */}
  <div className="form">
    <div className="step1_grid">
    <Row className="mb-3">
       
    {/* <h2>{count}</h2> */}
        <Form.Group as={Col} controlId="formGridPassword">
          <p className="defectp">Sample #</p>
          <Form.Control type="text"  name="samplecoffeeid" value={data.samplecoffeeid} placeholder={data.samplecoffeeid===""?"Enter Sample #":data.sampleCoffeeId}  onChange={handleChange} />
        </Form.Group>
      </Row>
      <p className="defectp">Roast Level</p>
      
        <Roast name="roast" handleChange={handleChange} data={data} count={count} />
       <p className="defectp">Aroma Level</p>
        <AromaLevel name="aromalevel" handleChange={handleChange} data={data} count={count} />
        <div className="score">
          <Form.Control name="aromascore" min="6" max="10" step="0.25" readOnly onChange={handleChange} type="number" value={data.aromalevel} placeholder={data.aromalevel===""?"Score Aroma":data.aromalevel} bsPrefix="scoretxt" />
        </div>
        <div className="intensityrow">
          <p className="defectp">Dry </p>
          <AromaDryIntensity name="aromadryintensity" handleChange={handleChange} data={data} count={count}/>
        </div>

        <div className="intensityrow">
          <p className="defectp">Break </p>

          <AromaBreakIntensity name="aromabreakintensity" handleChange={handleChange} data={data} count={count}/>
        </div>

        <div className="row2">
          <p className="defectp">Dry: </p>
          <Form.Control className="fromcontrol" name="aromadrycomment" onChange={handleChange} type="text" value={data.aromadrycomment} placeholder={data.aromadrycomment===""?"What Do you Think about the driness? ":data.aromadrycomment} />
        </div>

        <div className="row2">
          <p className="defectp">Break: </p>
          <Form.Control className="fromcontrol" name="aromabreakcomment" onChange={handleChange} type="text" value={data.aromabreakcomment} placeholder={data.aromabreakcomment===""?"What Do you Think about the break intensity? ":data.aromabreakcomment} />
        </div>
        <Form.Control name="notesbreak"  onChange={handleChange} as="textarea" rows={3} value={data.notesbreak} placeholder={data.notesbreak===""?"Notes Break":data.notesbreak}/>
        <br></br>
        <Form.Control name="notesdry"  onChange={handleChange} as="textarea" rows={3} value={data.notesdry} placeholder={data.notesdry===""?"Notes Dry":data.notesdry}/>
        <div className="row2"></div>
       
   {/* <Button variant="outline-primary"
          onClick={handleNext}>
         Next
    </Button> */}
   
   
      </div>
   </div>

    {/* STEP #2 */}
    <div className="form" >
    <div className="step2_grid">
      <p className="defectp">Flavour Level</p>
        <FlavourLevel name="flavourlevel" handleChange={handleChange} data={data} count={count} />
        <div className="score">
        <Form.Control   name="flavourscore" min="6" max="10" step="0.25" readOnly onBlur= {handleChange} type="number" value={data.flavourlevel}   bsPrefix="scoretxt"/>
      </div>
            <div className="intensityrow">
            <p className="defectp">Flavour </p>
            <FlavourIntensity name="flavourintensity" handleChange={handleChange} data={data} count={count}/>
            </div>
            <p className="defectp">Aftertaste</p>
              <AftertasteLevel name="aftertestlevel" handleChange={handleChange} data={data} count={count} />
              <div className="score">
                {/* only desplaying the value */}
            <Form.Control name="aftertestscore" min="6" max="10" step="0.25" readOnly onChange= {handleChange} value={data.aftertestlevel} type="number" placeholder={data.aftertestscore===""?"Score":data.aftertestscore} bsPrefix="scoretxt"/>
            </div>
            <div className="intensityrow">
            <p className="defectp">Duration</p>
            <AftertasteIntesity name="aftertestduration" handleChange={handleChange} data={data} count={count}/>
            </div>
            
            
            
            <p className="defectp">Acidity</p>
              <AcidityLevel name="aciditylevel" handleChange={handleChange} data={data} count={count} />
              <div className="score">
            <Form.Control name="acidityscore"  min="6" max="10" step="0.25" readOnly onChange= {handleChange} type="number" value={data.aciditylevel} placeholder={data.acidityscore===""?"Score":data.acidityscore} bsPrefix="scoretxt"/>
            </div>
            <div className="intensityrow">
           
            <p className="defectp">Intensity </p>
            <AcidityIntensity name="acidityintensity" handleChange={handleChange} data={data} count={count} />

            </div>
            <Form.Control name="aciditycharacter"  onChange= {handleChange} as="textarea" rows={3} value={data.aciditycharacter} placeholder={data.aciditycharacter===""?"Character":data.aciditycharacter}/>
            <div className="row2"></div>

            
            <p className="defectp">Mouthfeel</p>
              <MouthfeelLevel name="mouthfeellevel" handleChange={handleChange} data={data} count={count}/>
              <div className="score">
            <Form.Control name="mouthfeelscore" min="6" max="10" step="0.25" readOnly onChange= {handleChange} type="number" value={data.mouthfeellevel} placeholder={data.mouthfeelscore===""?"Score " :data.mouthfeelscore} bsPrefix="scoretxt"/>
            </div>
            <div className="intensityrow">
            <p className="defectp">Body </p>
            <MouthfeelIntensity name="mouthfeelbody" handleChange={handleChange} data={data} count={count}/>
            </div>
            
            <Form.Control name="mouthfeelcharacter"  onChange= {handleChange} as="textarea" rows={3} value={data.mouthfeelcharacter} placeholder={data.mouthfeelcharacter===""?"Character":data.mouthfeelcharacter}/>
            <div className="row2"></div>

            

            <p className="defectp">Unqiness/Appeal</p>
            <UnqinessLevel name="uniquenesslevel" handleChange={handleChange} data={data} count={count}/>
            <div className="score">
            <Form.Control name="uniquenessscore" min="6" max="10" step="0.25" readOnly onChange= {handleChange} type="number" value={data.uniquenesslevel} placeholder={data.uniquenessscore===""?"Score":data.uniquenessscore} bsPrefix="scoretxt"/>
            </div>
            

            <p className="defectp">Balance</p>
            <BalanceLevel name='balancelevel' handleChange={handleChange} data={data} count={count}/>
            <div className="score">
          <Form.Control name="balancescore" min="6" max="10" step="0.25" readOnly onChange= {handleChange} type="number" value={data.balancelevel} placeholder={data.balancescore===""?"Score":data.balancescore}  bsPrefix="scoretxt"/>
          </div>
            
            <p className="defectp">Uniformity</p>
            <div  className="uniformCups"
            // onChange={onChangeValueUniform}
            >
              <div className="checkboxflex">
              <div style={{ display: 'flex', alignItems: 'center' }} onChange={onChangeValue1}>
              <Form.Check aria-label="option 1" value={!val1} name="uniformcups1"  checked={'' + data.uniformcups1 === "true"} />
              <span role="img" aria-label="coffee">☕</span>
              </div>
              <div style={{ display: 'flex', alignItems: 'center' }} onChange={onChangeValue2}>
                <Form.Check aria-label="option 2" value={!val2} name="uniformcups2" checked={'' + data.uniformcups2 === "true"} />
                <span role="img" aria-label="coffee">☕</span>
              </div>
              <div style={{ display: 'flex', alignItems: 'center' }} onChange={onChangeValue3}>
                <Form.Check aria-label="option 3" value={!val3} name="uniformcups3" checked={'' + data.uniformcups3 === "true"}/>
                <span role="img" aria-label="coffee">☕</span>
              </div>
              <div style={{ display: 'flex', alignItems: 'center' }} onChange={onChangeValue4}>
                <Form.Check aria-label="option 4" value={!val4} name="uniformcups4" checked={'' + data.uniformcups4 === "true"}/>
                <span role="img" aria-label="coffee">☕</span>
              </div>
              <div style={{ display: 'flex', alignItems: 'center' }} onChange={onChangeValue5}>
                <Form.Check aria-label="option 5" value={!val5} name="uniformcups5" checked= {'' + data.uniformcups5 === "true"}/>
                <span role="img" aria-label="coffee">☕</span>
              </div>
              </div>
            </div>
            <div className="score">
            <Form.Control name="uniformityscore" min="0" onChange= {handleChange} type="number" value={data.uniformityscore} placeholder={data.uniformityscore===""?"Score":data.uniformityscore} bsPrefix="scoretxt"/>
            </div>

            

            <p className="defectp">Clean Cup</p>
            <div className="uniform"
            // onChange={onChangeValueCleanCup}
            >
              <div className="checkboxflex">
              <div style={{ display: 'flex', alignItems: 'center' }} onChange={onChangeValue6}>
              <Form.Check aria-label="option 6" name="cleancupcups1" value={!val6}  checked={'' + data.cleancupcups1 === "true"} />
              <span role="img" aria-label="coffee">☕</span>
              </div>
              <div style={{ display: 'flex', alignItems: 'center' }} onChange={onChangeValue7}>
                <Form.Check aria-label="option 7" name="cleancupcups2" value={!val7}  checked={'' + data.cleancupcups2 === "true"}  />
                <span role="img" aria-label="coffee">☕</span>
              </div>
              <div style={{ display: 'flex', alignItems: 'center' }} onChange={onChangeValue8}>
                <Form.Check aria-label="option 8" name="cleancupcups3" value={!val8} checked={'' + data.cleancupcups3 === "true"} />
             <span role="img" aria-label="coffee">☕</span>
              </div>
              <div style={{ display: 'flex', alignItems: 'center' }} onChange={onChangeValue9}>
                <Form.Check aria-label="option 9" name="cleancupcups4" value={!val9}  checked={'' + data.cleancupcups4 === "true"} />
             <span role="img" aria-label="coffee">☕</span>
              </div>
              <div style={{ display: 'flex', alignItems: 'center' }} onChange={onChangeValue10}>
                <Form.Check aria-label="option 10" name="cleancupcups5" value={!val10}  checked={'' + data.cleancupcups5 === "true" } />
              <span role="img" aria-label="coffee">☕</span>
              </div>
              </div>
            </div>
            <div className="score">
            <Form.Control name="cleancupscore" min="0" onChange= {handleChange} type="number" value={data.cleancupscore} placeholder={data.cleancupscore===""?"Score":data.cleancupscore} bsPrefix="scoretxt"/>
            </div>
              

          
            <div className="uniform" 
            // onChange={onChangeValueSweetness}
            >

            <p className="defectp">Sweetness</p>
            <div className="uniform" >

              <div className="checkboxflex">
              <div style={{ display: 'flex', alignItems: 'center' }} onChange={onChangeValue11}>
              {/* data.sweetCups==0?data.sweetCups.includes("1"):val11  */}
              <Form.Check aria-label="option 11" name="sweetcups1" value={!val11}  checked={'' + data.sweetcups1 === "true" } />
              <span role="img" aria-label="coffee">☕</span>
              </div>
              <div   style={{ display: 'flex', alignItems: 'center' }} onChange={onChangeValue12}>
                <Form.Check aria-label="option 12" name="sweetcups2" value={!val12}  checked={'' + data.sweetcups2 === "true" }/>
                <span role="img" aria-label="coffee">☕</span>
              </div>
              <div   style={{ display: 'flex', alignItems: 'center' }} onChange={onChangeValue13}>
                <Form.Check aria-label="option 13" name="sweetcups3" value={!val13}  checked={'' + data.sweetcups3 === "true" }/>
             <span role="img" aria-label="coffee">☕</span>
              </div>
              <div  style={{ display: 'flex', alignItems: 'center' }} onChange={onChangeValue14}>
                <Form.Check aria-label="option 14" name="sweetcups4" value={!val14}  checked={'' + data.sweetcups4 === "true" }/>
             <span role="img" aria-label="coffee">☕</span>
              </div>
              <div  style={{ display: 'flex', alignItems: 'center' }} onChange={onChangeValue15}>
                <Form.Check aria-label="option 15" name="sweetcups5" value={!val15}  checked={'' + data.sweetcups5 === "true"}/>
              <span role="img" aria-label="coffee">☕</span>
              </div>
              </div>
            </div>
            <div className="score">
            <Form.Control name="sweetnessscore" min="0" onChange= {handleChange} type="number" value={data.sweetnessscore} placeholder={data.sweetnessscore===""?"Score":data.sweetnessscore} bsPrefix="scoretxt"/>
      
            </div>
           
            <div className="intensityrow">
            <p className="defectp">Intesity </p>
            <SweetnessIntensity name="sweetnessintensity" handleChange={handleChange} data={data} count={count} />
            </div>


            <div className="row2"></div>
          <div className="buttonjustify">

            {/* <Button variant= "outline-danger"
                            onClick={handlePrev}>
                              Back
            </Button>
              <span>....</span>
              <Button 
                    variant="outline-primary"
                    onClick={handleNext}>
                    Next
              </Button> */}

        </div>
      </div>
            </div>
            </div>


{/* STEP #4 */}
            <div className="form">
      <div className="step_4">
    <Row className="agingf">
      <Col>
    <p className="defectp">Aging</p>
      <Aging name="aging" handleChange={handleChange} data={data} count={count}/>
      </Col>
       <Col>
     <p className="defectp">Ferment Profile </p>
      <FermentProfile name="fermentprofile" handleChange={handleChange} data={data} count={count} />
      </Col>
    </Row>
    
    <div className="general_character">
         <p className="defectp">General Character</p>
        <AppCheckBox handleChange={handleChange} 
        handleChangeUni={handleChangeUni}
         data={data} count={count}/>

        {/* <Button variant="outline-danger"
          onClick={handlePrev}>
          Back </Button> <span>....</span>
        <Button variant="outline-primary"
          onClick={handleNext}>
          Next
        </Button> */}
        </div>
      </div>
      </div>
      {/* STEP #3 */}

      <div className="form">
        <div className="step3_grid">

       
          <p className="defectp">Moisture content</p>
          <Form.Control name="moisturecontent"  onChange= {handleChange} type="text" value={data.moisturecontent} placeholder={data.moistureContent===""?"Moisture ":data.moistureContent} />
          
          <p className="defectp">Density</p>
          <Form.Control name="density"  onChange= {handleChange} type="text"  value={data.density} placeholder={data.density===""?"Density ":data.density} />
          <div className="row2"></div>

          <p className="defectp">AW</p>
          <Form.Control name="aw"  onChange= {handleChange} type="text"  value={data.aw} placeholder={data.aw===""?"AW ":data.aw} />
          <div className="row2"></div>
          
          <p className="defectp">Quaker Count</p>
          <Form.Control name="quakercount"  onChange= {handleChange} type="text" value={data.quakercount} placeholder={data.quakercount===""?"Quaker Count ":data.quakercount} />
          <div className="row2"></div>
          <p className="defectp">Defects</p>
          <div className="defectsdiv">
            <Form.Control name="defectsc"  onChange= {handleChange} type="number" min="0" value={data.defectsc} placeholder={data.defectsc===null?"#C":data.defectsc} bsPrefix="defectsdivtxt"/>
            <p className="defectp">X</p>
            <Form.Control name="defectsintensity"  onChange= {handleChange} min="0" type="number" value={data.defectsintensity} placeholder={data.defectsintensity===""?"Intensity " :data.defectsintensity}bsPrefix="defectsdivtxt"/>
          </div>
          <div className="row2"></div>
          <p className="defectp">Defects Note</p>
          <Form.Control name="defectsnote" as="textarea"  onChange= {handleChange} type="text" value={data.defectsnote} placeholder={data.defectsnote===""?"Defects Note ":data.defectsnote} />
          <div className="row2"></div>

          <p className="defectp">Total Score</p>
          <Form.Control name="totalscore" type="number" min="0" value={
          totalScore} placeholder={data.totalscore===""?"Total Score ":data.totalscore} readOnly ref={myInputRef} />
          
          <p className="defectp">Total Defects</p>
          <Form.Control name="totaldefects" type="number" min="0" value={totalDefects} placeholder={data.totaldefects===""?"Total Defects ":data.totaldefects} readOnly ref={myInputRef2}/>
          <div className="row2"></div>

          <p className="defectp">Final Score</p>
          <Form.Control name="finalscore" type="number" min="0"  value={totalScore - totalDefects} placeholder={data.finalscore===""?"Final Score ":data.finalscore} readOnly />
          <div className="row2"></div>
         
          <p className="defectp">Profile</p>
          <Form.Control name="profile" as="textarea" onChange= {handleChange} type="text" value={data.profile} placeholder={data.profile===""?"Profile ":data.profile} />
         <div className="row2"></div>
          <p className="defectp">Notes Negative</p>
          <Form.Control name="notesnegative" as="textarea" onChange= {handleChange} type="text" value={data.notesnegative} placeholder={data.notesNegative===""?"Notes Negative ":data.notesNegative} />
         <div className="row2"></div>
            <div className="buttonjustify">
         
     {/* { length <= 0 && count <= 0 && (
      <Button 
         className="w-100"
         style={{
          paddingTop: '20px'
         }}
          variant="success"
          onClick={handleNext}>
          Submit 
    </Button>
     ) } */}
     

    </div>
            </div>
           
      </div>
    </>
      
    
  );
};

export default TheStep;
